export default {
  showHistoryDialog(state, payload) {
    state.showHistoryDialog = payload;
  },
  sourceAddress(state, payload) {
    state.sourceAddress = payload;
  },
  subject(state, payload) {
    state.subject = payload;
  },
  content(state, payload) {
    state.content = payload;
  },
};
